<mat-menu #menu   >
    <span  class="theme-container">
    <ng-container *ngFor="let item of items$">
  
      <a 	(click)="goToCategory(item)" *ngIf="item.subcategories.length==0; else branch" mat-menu-item class="textcss">{{item.categoryName}}</a>
      <ng-template #branch>
        <a mat-menu-item [matMenuTriggerFor]="innerPanel.menu" (click)="goToCategory(item)" class="textcss">{{item.categoryName}}</a>
        
        <calsoft-menu2 [data]="data" (mouseenter)="menuenter()" (mouseleave)="menuLeave(levelOneTrigger, button)" #innerPanel [items$]="item.subcategories"></calsoft-menu2>
      </ng-template>
    </ng-container>
    </span>
  </mat-menu>
